import { Button, Container, Overlay, Text, Title } from '@mantine/core';
import classes from './HeroContent.module.css';
import familyImage from '../../imgs/family-2.jpg';

export function HeroContent() {
  return (
    <section className={classes.hero} style={{ backgroundImage: `url(${familyImage})` }} id="inicio">
      <Overlay
        gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 40%)"
        opacity={1}
        zIndex={0}
      />
      <Container className={classes.container} size="md">
        <Title className={classes.title}>
          Tu préstamo al instante,
          <br />
          sin dejar el volante
        </Title>
        <Text className={classes.description} size="xl" mt="xl">
          Recibe hasta el 80% del valor de tu auto con una
        </Text>
        <Text
          inherit
          component="span"
          variant="gradient"
          className={classes.descriptionRate}
          gradient={{ from: '#37b6fd', to: 'green' }}
        >
          tasa del 3%
        </Text>

        <Button
          role="link"
          aria-label="Contáctanos"
          variant="gradient"
          size="xl"
          radius="xl"
          className={classes.control}
          onClick={() => (window.location.href = '#contacto')}
        >
          Contáctanos
        </Button>
      </Container>
    </section>
  );
}
